
import React, { useState, useEffect } from 'react';
import './ModalEditBillItem.scss';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { Button } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import { updateLocalBillCategoryById } from '../../../../../../../../../../../../crud/management_api/local_bill_category';
import { toast } from 'react-toastify';

interface ModalEditBillItemProps {
  show: boolean;
  handleClose: () => void;
  item: {
    bill_item_id: number;
    item_name: string;
    item_description?: string;
    [key: string]: any;
  };
  handleEditItem: (editedItem: { bill_item_id: number; item_name: string; item_description?: string; local_bill_category_id: number }) => void;
}

const ModalEditBillItem: React.FC<ModalEditBillItemProps> = ({
  show,
  handleClose,
  item,
  handleEditItem,
}) => {
  const [itemName, setItemName] = useState(item.item_name || '');
  const [itemDescription, setItemDescription] = useState(item.item_description || '');

  useEffect(() => {
    if (show) {
      setItemName(item.item_name || '');
      setItemDescription(item.item_description || '');
    }
  }, [show, item]);

  const isItemValid = itemName.trim() !== '';

  const handleSaveEdit = async () => {
    if (!isItemValid) {
      toast.warn('Por favor, completa todos los campos requeridos.');
      return;
    }
    if (!item.local_bill_category_id) {
      toast.error('No se encontró el identificador de la categoría local.');
      return;
    }
    try {
      await updateLocalBillCategoryById(item.local_bill_category_id, {
        category_name: itemName,
        category_description: itemDescription,
      });
      // Actualiza el objeto local para reflejar el cambio en tiempo real
      item.item_name = itemName;
      item.item_description = itemDescription;
      handleEditItem({
        bill_item_id: item.bill_item_id,
        item_name: itemName,
        item_description: itemDescription,
        local_bill_category_id: item.local_bill_category_id,
      });
      toast.success('Cuenta actualizada correctamente.');
      handleClose();
    } catch (error) {
      toast.error('Error al actualizar la cuenta.');
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header>
        <div className="form-modal-title-container">
          <Modal.Title className="form-modal-title">Editar Ítem de Cuenta</Modal.Title>
        </div>
        <Button variant="none" className="close-modal-btn" onClick={handleClose}>
          <X size={24} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mp-formgroup horizontal" controlId="itemName">
            <Form.Label>Nombre del Ítem</Form.Label>
            <Form.Control
              type="text"
              placeholder="Ingrese el nombre"
              value={itemName}
              onChange={(e) => setItemName(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group className="mp-formgroup vertical" controlId="itemDescription">
            <Form.Label>Descripción</Form.Label>
            <Form.Control
              type="text"
              placeholder="Ingrese una descripción"
              value={itemDescription}
              onChange={(e) => setItemDescription(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="none" className="form-button-cancel" onClick={handleClose}>
          Cancelar
        </Button>
        <Button
          variant="none"
          className="form-button-create"
          onClick={handleSaveEdit}
          disabled={!isItemValid}
        >
          Guardar Cambios
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalEditBillItem;